import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2} from '../common';

// The metaphor with Barbie and Ken in the biblioteca
export const ken = {
  name: "ken",
  header: <span>
    The QM/GR divide is analogous to this story about Barbie and Ken
  </span>,
  outside: <span>Because yes, <WName /> claims all six ‘<LRL>nobel prizes</LRL>’ <i>simultaneously</i>, claims to have unified QM and GR… and then churns out ‘crup’ like <i>this</i>.</span>,
  preview: <div className="angle-preview">
    <p>This is an <AL home>angle</AL> on <AL name="fields.">science</AL> that’s similar to many <AL name="religion">religions</AL>, whether they <PL name="form">view</PL> <QL>consciousness</QL> (and <NW>agency</NW>) as ‘<NW>God</NW>’ or as <E2 suffix="ed" /> by the <PL>individual</PL> ‘<OML>soul</OML>’, and <LRL>reactivity</LRL> (and <NW>apartheid</NW>) as ‘<PL name="privacy.">the Devil</PL>’… or whether it’s a <AL name="religion.hindu.purusha">पुरुष</AL>-<AL name="religion.hindu.prakriti">प्रकृति</AL> divide. <NW>God</NW>/<NW>agency</NW> as <PL>infinity</PL> (proof: a <QL>human</QL> <NW>khet</NW> could theoretically pick/describe <i>any number</i>; there are infinitely many), and (predetermined/mechanistic) <LRL>reactivity</LRL> as ‘<PL name="ban">finity</PL>’, cf. <PL>Safety</PL> culture.</p>
    <p>[Under construction; basically Barbie 'atomised' Ken (we don't know why) and put him in a biblioteca (think Borges) and now he's trying to recombine; QM is the structure in which Ken (as many many separate 'minds') is placed and GR -- along with <QL>time</QL> -- are the <AL name="limits">rules</AL> he (and parts of him; as <NW>POCs</NW> we are all <AL name="sick.">fragments</AL> of 'Ken') must follow to try to recombine into one 'Ken' (or, you know, '<NW>God</NW>') ]</p>
  </div>,
//  text: <div className="angle-text">
//    <p><PL name="ch.">Uwa</PL> came out in all <QL name="gippetian"‘’</p>
//  </div>,
};

